export type IAppointmentPageType = keyof typeof IAppointmentPageTypeEnum;
export enum IAppointmentPageTypeEnum {
  "online-visit",
  "in-person-visit",
}
